import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import RenderOnlyField from "@Components/FormikControl/RenderOnlyField";

const GrievanceClosedDetails = (props) => {
  const { passedValue } = props;
  const [pendingCloseBy, pendingCloseAt, closedBy, closedAt] = passedValue;

  return (
    <Grid container>
      <Grid item xs={12} lg={3}>
        <RenderOnlyField label="Pending Close By" value={pendingCloseBy} />
      </Grid>

      <Grid item xs={12} lg={3}>
        <RenderOnlyField
          label="Pending Close Date & Time"
          value={pendingCloseAt}
          valueType="date_time"
        />
      </Grid>

      <Grid item xs={12} lg={3}>
        <RenderOnlyField label="Closed By" value={closedBy} />
      </Grid>

      <Grid item xs={12} lg={3}>
        <RenderOnlyField
          label="Closed Date & Time"
          value={closedAt}
          valueType="date_time"
        />
      </Grid>
    </Grid>
  );
};

GrievanceClosedDetails.propTypes = {
  passedValue: PropTypes.any,
};

export default GrievanceClosedDetails;
